import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { serviceSlugs } from "@/i18n/serviceDetails";

const CARLISLE_PHOTO =
  "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/o1s1gwoq_filtersformatwebpquality75.webp";
const CARLISLE_LOGO =
  "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/mphru06k_carlisle-logo-4c.svg";

const IMAGES = [
  "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/sgdtfm4q_WhatsApp%20Image%202026-06-15%20at%2011.46.20.jpeg",
  CARLISLE_PHOTO,
  "https://images.pexels.com/photos/1078884/pexels-photo-1078884.jpeg?auto=compress&cs=tinysrgb&w=1200",
];

const Services = () => {
  const { t } = useLang();
  const [hover, setHover] = useState(null);

  return (
    <section id="services" data-testid="services-section" className="bg-[var(--bg-dark)] text-white py-24 md:py-36 relative overflow-hidden grain">
      <div className="container-page relative">
        <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.18em] text-white/50 mb-10">
          <span className="w-8 h-px bg-white/40" />
          {t.services.eyebrow}
        </div>

        <h2 data-testid="services-title" className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-3xl">
          {t.services.title}
        </h2>

        <div className="mt-20 border-t border-white/15">
          {t.services.items.map((item, i) => {
            const isCarlisle = i === 1;
            return (
              <Link
                key={i}
                to={`/services/${serviceSlugs[i]}`}
                data-testid={`service-item-${i}`}
                onMouseEnter={() => setHover(i)}
                onMouseLeave={() => setHover(null)}
                className="group grid grid-cols-12 items-center gap-6 border-b border-white/15 py-8 md:py-10 transition-colors hover:bg-white/[0.02]"
              >
                <div className="col-span-12 md:col-span-2 font-mono text-xs uppercase tracking-[0.2em] text-white/50">
                  {item.tag}
                </div>
                <div className="col-span-12 md:col-span-6 font-display text-3xl md:text-5xl tracking-tight">
                  <span className="inline-block transition-transform duration-500 group-hover:translate-x-3">
                    {item.title}
                  </span>
                  {isCarlisle && (
                    <div className="mt-4 flex items-center gap-3" data-testid="carlisle-badge">
                      <span className="inline-flex items-center bg-white rounded-sm px-2.5 py-1.5">
                        <img
                          src={CARLISLE_LOGO}
                          alt="CARLISLE® Construction Materials"
                          className="h-5 md:h-6 w-auto"
                        />
                      </span>
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 hidden md:inline">
                        · Authorized Installer
                      </span>
                    </div>
                  )}
                </div>
                <div className="col-span-12 md:col-span-3 text-sm text-white/60 leading-relaxed">{item.body}</div>
                <div className="col-span-12 md:col-span-1 text-right text-2xl text-white/40 transition-all group-hover:text-[var(--accent)] group-hover:translate-x-2">
                  →
                </div>
              </Link>
            );
          })}
        </div>

        {/* Floating preview image */}
        <div
          className="hidden lg:block fixed top-1/2 left-1/2 w-72 h-96 pointer-events-none z-40 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300"
          style={{ opacity: hover !== null ? 0.9 : 0 }}
          aria-hidden
        >
          {hover !== null && (
            <img src={IMAGES[hover]} alt="" className="w-full h-full object-cover" />
          )}
        </div>
      </div>
    </section>
  );
};

export default Services;
